import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Divider,
  Box,
  useTheme,
  lighten,
} from '@mui/material';
import { palette } from '../theme/palette';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ReactComponent as CopyIcon } from '../assets/icons/main/copy-icon.svg';
import { ReactComponent as Close } from '../assets/icons/main/close-icon.svg';
import { get } from 'lodash';
import { useOutletContext } from 'react-router-dom';


import Snackbar from '../common/snackBar';

const styles = {
  title: {
    height: '20px',
  },
  message: {
    marginTop: '16px',
    marginBottom: '8px'
  },
};

const PopUp = ({
  open,
  title,
  icon,
  message,
  cancel,
  cancelLabel,
  confirmation,
  confirmLabel,
  showUserDetails,
  userDetails,
  textToCopy,
  onConfirm = () => {},
  onCancel = () => {},
  onClose = () => {},
  children
}: any) => {
  const themeData = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  return (
    <Dialog
      maxWidth='md'
      open={open}
      sx={{
        '& [class*=MuiDialog-paperWidthMd]': {
          width: '500px',
          height: 'auto',
          left: '50%',
          top: '46%',
          transform: 'translateX(-50%) translateY(-50%)',
          position: 'absolute',
          borderRadius: '18px',
          background: themeMode.isLightBG
            ? themeData.palette.background.paper
            : lighten(themeData.palette.background.default, 0.08),
        },
      }}
    >
      <Box sx={{display: 'flex', justifyContent: 'flex-end', p: 2}}>
        <IconButton onClick={onClose}>
          <Close style={{ color: themeData.palette.custom.light }} />
        </IconButton>
      </Box>
      <DialogTitle>
        {icon && (
          <Box>
            <Box
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              {icon}
            </Box>
          </Box>
        )}
      </DialogTitle>
      <DialogContent
        sx={{
          justifyContent: 'center',
        }}
      >
        {title && (
          <div style={{ marginTop: '20px' }}>
            <Typography
              align='center'
              variant='h1'
              style={{ ...styles.title, color: title === 'SUCCESS' ? palette.success.dark : palette.warning.main }}
            >
              {title}
            </Typography>
          </div>
        )}
        <Typography
          align='center'
          variant='subtitle1'
          style={{ ...styles.message, color: themeData.palette.text.secondary }}
        >
          {message}
        </Typography>
        {children}
        {showUserDetails && (
          <>
            <Divider sx={{ height: '1px' }} />
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: '4px' }}>
              <Box sx={{ paddingRight: '16px' }}>
                <Typography variant='subtitle1'> UserName : {userDetails.username}</Typography>
                <Typography variant='subtitle1'> Password : {userDetails.password}</Typography>
              </Box>
              <Box>
                <CopyToClipboard
                  text={textToCopy}
                  onCopy={() => {
                    Snackbar.info('Copied!');
                  }}
                >
                  <IconButton>
                    <CopyIcon style={{ color: themeData.palette.custom.light }} />
                  </IconButton>
                </CopyToClipboard>
              </Box>
            </Box>
            <Divider sx={{ height: '1px' }} />
          </>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', marginBottom: '40px' }}>
        {cancel && (
          <Button onClick={onCancel} variant='outlined' size='medium' color='primary' sx={{minWidth:'134px'}}>
            {cancelLabel}
          </Button>
        )}
        {confirmation && (
          <Button onClick={onConfirm} variant='contained' sx={{minWidth:'134px'}} >
            {/* size='medium' */}
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PopUp;
